/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import LCD from '@appblocks/codegeneration/Features/LCD';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const lcdFeatureId = feature.project.getFeature('lcd')?.getID();


    const links = project.getNodeLinks(feature, 'lcd_menu_enter');
    for (let i = 0; i < links.length; i += 1) {
        const link = links[i];
        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `
simulator.updateContext("${lcdFeatureId}", {
    ...simulator.context["${lcdFeatureId}"],
    MENU_OPEN: true,
})
simulator.updateContext("pat", {
    pattern: 'RG~',
})
`,
        });
    }

    return blocks;
};
